<app-dialog
  [dialogType]="dialogType"
  [headerLabel]="'DIALOG.UPDATE_DEPOSIT_REQUEST.TITLE' | translate"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionText]="
    'DIALOG.UPDATE_DEPOSIT_REQUEST.UPDATE_REQUEST' | translate
  "
  [primaryActionTapped]="primaryActionTapped"
  [secondaryActionText]="
    'DIALOG.UPDATE_DEPOSIT_REQUEST.CANCEL_REQUEST' | translate
  "
  [secondaryActionTapped]="secondaryActionTapped"
  [stackActions]="true"
  (onPrimaryAction)="onUpdateDepositRequest.emit()"
  (onSecondaryAction)="onCancelDepositRequest.emit()"
>
  <div id="update-deposit-request-dialog">
    <p class="info">
      {{ 'DIALOG.UPDATE_DEPOSIT_REQUEST.INFO' | translate }}
    </p>
  </div>
</app-dialog>
